import { Component, OnInit, AfterViewInit } from '@angular/core';
import { fciWebsiteService } from '../../service/fci-website.service';
import { ActivatedRoute, Router } from '@angular/router';
import { EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { environment } from 'src/environments/environment';
import { HttpEvent, HttpEventType } from '@angular/common/http';
declare let $: any;
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-hospital-list-fci-hqrs',
  templateUrl: './hospital-list-fci-hqrs.component.html',
  styleUrls: ['./hospital-list-fci-hqrs.component.css']
})
export class HospitalListFciHqrsComponent implements OnInit {

  constructor(private fciwebservice: fciWebsiteService, private ngxLoader: NgxUiLoaderService, private routerparam: ActivatedRoute,private encDec:EncryptDecryptService, private route: Router,public translate: TranslateService) { }
  hospitalResponse:any;
  content_apiresponse:any; 
  searchForm = new FormGroup({
    title: new FormControl(''),
    purpose: new FormControl(''),
    to_date: new FormControl(''),
    from_date:new FormControl(''),
  })
  language = sessionStorage.getItem('locale');//dynamic
  ngOnInit(): void {
    

    this.start=(this.currentPage - 1)*this.limit;
    this.getHospitalData('','','','',this.start,this.limit,this.currentPage);
  }
  get title() {
    return this.searchForm.get('title');
  }
  get purpose() {
    return this.searchForm.get('purpose');
  }
  get from_date() {
    return this.searchForm.get('from_date');
  }
  get to_date() {
    return this.searchForm.get('to_date');
  }
  hasPhone:any;
  phonenum:any;
  start:number=0;
  limit:number=10;
  currentPage:number = 1;
  totalRecords:number=0;
  count:any;
  isdisplay: boolean = false;
   getHospitalData(title:any,purpose:any,from_date:any,to_date:any,start:number,limit:number,currentPage:number){

    var query:any=[];
    query = [{ "columnName": "tinPublishStatus", "operator": "=", "value": 1, "joinoperator": "and" },
              { "columnName": "bitDeletedFlag", "operator": "=", "value": 0, "joinoperator": "and" },
    ]; 
    let params = [{
      "secSlNo":1,
      "offSet":start,
      "noOfRecords":limit,
      "orderBy":[{"columnName":"intId","type":"DESC"}], 
      "condition":query,
       "viewParameters":"",
    }];
    if(title!==""){
      query.push({ "columnName": "VCHHOSPIALNAME", "operator": "LIKE", "value": `%${title}%`, "joinoperator": "and" });
    }
    if(purpose!==""){
      query.push({ "columnName": "VCHPURPOSE", "operator": "LIKE", "value": `%${purpose}%`, "joinoperator": "and" });
    }
    
    if(from_date!=="" && to_date==''){
      query.push({ "columnName": "VCHEMPON", "operator": ">=", "value": from_date, "joinoperator": "and" });
    } else if(from_date=="" && to_date!==''){
      query.push({ "columnName": "VCHEMPUPTO", "operator": ">=", "value": to_date, "joinoperator": "and" });
    } else if(from_date!=="" && to_date!==''){
      query.push({ "columnName": "VCHEMPON", "operator": ">=", "value": from_date, "joinoperator": "and" });
      query.push({ "columnName": "VCHEMPUPTO", "operator": ">=", "value": to_date, "joinoperator": "and" });
      
    }
    this.fciwebservice.getHospitalData(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.content_apiresponse = response.body;
          let respData = this.content_apiresponse.RESPONSE_DATA;
          let respToken = this.content_apiresponse.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response: any = Buffer.from(respData, 'base64');
            response = JSON.parse(response);
            this.hospitalResponse = response.result.sec_1;
          //  console.log(this.hospitalResponse);
            if(response.result.sec_1.length > 0){
              this.totalRecords = response.result.sec_1[0].noOfRec;
              this.issearch = true;
            } else {
              this.totalRecords = 0;
              this.issearch = false;
            }
          } 
          this.ifdisabled = false;
          this.btncontent = this.language=='English'?`Search`:`खोजें`;
      }
    });
   }
   htmldecode(str: any){
    return this.encDec.decodeHtml(str);
  }

  getPhone(data: any) {
    let telph = ''; 
  for (let i = 0; i < data.length; i++) {
   telph += data[i].telNo +' / ' ;

 }
   return telph.slice(0, -2);
  }

  RefreshBtn:boolean=false;
  RefreshPage(){
    this.start=0;
    this.limit=10;
    this.currentPage = 1;
    this.totalRecords = 0;
     this.getHospitalData('','','','',this.start,this.limit,this.currentPage);
    this.RefreshBtn = false;
    this.searchForm.reset();
   
  }

  
 
  ifdisabled:boolean=false;
  btncontent:any = this.language=='English'?`Search`:`खोजें`;
  issearch:any;
  searchHospitalList(){
    this.isdisplay = true;
    let param_arr = []; 
    let title,purpose,from_date,to_date;
    title="";
    purpose="";
    from_date="";
    to_date="";
    if(this.searchForm.value.title!==""){
      if(this.searchForm.value.title!==null){
        param_arr.push(this.searchForm.value.title);
        title = this.searchForm.value.title;
      }
    }
    if(this.searchForm.value.purpose!==""){
      if(this.searchForm.value.purpose!==null){
        param_arr.push(this.searchForm.value.purpose);
        purpose = this.searchForm.value.purpose;
      }
    }

    if(this.searchForm.value.from_date!==""){
      if(this.searchForm.value.from_date!==null){
        param_arr.push(this.searchForm.value.from_date);
        from_date = this.searchForm.value.from_date;
      }
    }
    if(this.searchForm.value.to_date!==""){
      if(this.searchForm.value.to_date!==null){
        param_arr.push(this.searchForm.value.to_date);
        to_date = this.searchForm.value.to_date;
      }
    }
    
    if(param_arr.length <= 0){
     
      Swal.fire({
        icon: 'warning',
        text: (this.language=='English') ? "Please select at least one parameter" : "कृपया कम से कम एक पैरामीटर चुनें",
      });
      return;
    }
    this.RefreshBtn=true;
    this.start=0;
    this.limit=10;
    this.currentPage = 1;
    this.totalRecords = 0;
    this.getHospitalData(title,purpose,from_date,to_date,this.start,this.limit,this.currentPage);
    
  }
  pageChanged(page: any) {
    this.currentPage=page
    this.start=(this.currentPage - 1)*this.limit;
    this.getHospitalData('','','','',this.start,this.limit,this.currentPage);
  }
}


